<script lang="ts">
	import ArticleCardHorizontal from "../components/ArticleCardHorizontal.svelte";
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./CaseStudies.translations.json";
	import type { CaseStudiesProps } from "./CaseStudiesProps.js";
	import { referenceToCard } from "../components/referenceToCard.js";
	import type { CardItem } from "../components/ArticleCardProps.js";
	import ContactForm from "../components/Contact/ContactForm.svelte";
	import HeadingSection from "../components/HeadingSection.svelte";

	type $$Props = CaseStudiesProps;

	const { references } = $$restProps as $$Props;

	interface CaseStudyItem {
		card: CardItem;
		date: string;
		labels: string[];
	}

	const items: CaseStudyItem[] = references
		.map(
			(reference): CaseStudyItem => ({
				card: referenceToCard(reference),
				date: reference.createdAt,
				labels: [...reference.scopeLabels, ...reference.useCaseLabels],
			}),
		)
		.sort((first, second) => Date.parse(second.date) - Date.parse(first.date));

	const translate = getTranslate(translations);
</script>

<Layout>
	<div class="container">
		<HeadingSection tag={translate("tag")} headline={translate("heading")}>
			<p>{translate("description1")}</p>
			<p class="mt-4">{translate("description2")}</p>
		</HeadingSection>
	</div>

	<section class="!mb-0">
		<div class="border-lttertiary border-y">
			<div class="mx-auto max-w-[120rem]">
				<div class="border-lttertiary mx-4 flex flex-col border-x md:mx-16 lg:mx-32 [&>*:last-child]:border-b-0">
					{#each items as item (item.card.href)}
						<ArticleCardHorizontal card={item.card} labels={item.labels} imageInset />
					{/each}
				</div>
			</div>
		</div>
	</section>

	<section class="!mb-0 !mt-16">
		<ContactForm />
	</section>
</Layout>
